import { yupResolver } from "@hookform/resolvers/yup";
import { Grid } from "@material-ui/core";
import { useRouter } from "@uirouter/react";
import { noop } from "lodash";
import moment from "moment";
import { FunctionComponent, useCallback, useMemo } from "react";
import { Controller, useForm } from "react-hook-form";
import { PrimaryButton } from "../../../../../components/button";
import { Password } from "../../../../../components/forms/password";
import { TextField } from "../../../../../components/forms/text";
import { useAppLoader } from "../../../../../components/loader/app-loader-hook";
import { AuthDTO } from "../../../../../store/auth/models/dto";
import { AuthService } from "../../../../../store/auth/service";
import { UsersService } from "../../../../../store/users/service";

export const CreateUserModal: FunctionComponent<{
  userReferenceId: string;
}> = ({ userReferenceId }) => {
  const loader = useAppLoader();
  const router = useRouter();

  const { validation } = AuthDTO.Requests.CreateIndividualUser.useFields();

  const {
    control,
    handleSubmit,
  } = useForm<AuthDTO.Requests.CreateIndividualUser.T>({
    resolver: yupResolver(validation),
    defaultValues: useMemo(
      () => ({
        nationality: "MT",
        dateOfBirth: moment("2001-09-27").toDate(),
      }),
      []
    ),
  });

  const onSubmit = useCallback(
    (x: AuthDTO.Requests.CreateIndividualUser.T) =>
      loader(
        AuthService.adminSignUp(x).then(({ userReferenceId: id }) =>
          UsersService.addDelegateUser(userReferenceId, id)
        )
      )
        .then(() => router.stateService.reload())
        .catch(noop),
    [userReferenceId, router, loader]
  );

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Controller
            control={control}
            name="firstName"
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                fullWidth
                label="First Name"
                helperText={error?.message}
                error={!!error}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            control={control}
            name="lastName"
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                fullWidth
                label="Last Name"
                helperText={error?.message}
                error={!!error}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            control={control}
            name="emailAddress"
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                fullWidth
                label="E-mail Address"
                helperText={error?.message}
                error={!!error}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            control={control}
            name="password"
            render={({ field, fieldState: { error } }) => (
              <Password
                {...field}
                fullWidth
                label="Password"
                helperText={error?.message}
                error={!!error}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            control={control}
            name="confirmPassword"
            render={({ field, fieldState: { error } }) => (
              <Password
                {...field}
                fullWidth
                label="Confirm Password"
                helperText={error?.message}
                error={!!error}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <PrimaryButton type="submit">Create</PrimaryButton>
        </Grid>
      </Grid>
    </form>
  );
};
